import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";

export class RelatedEntitiesWidgetCompetitorViewModel extends CompetitorViewModel {

  get relatedEntitySubText(): String {
    return this.mainCompetitionName || this.country.name;
  }
}
